module.exports = __webpack_public_path__ + "img/product_18.4d1c1b6.svg";